import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { WebapiService } from '../../shared/services/webapi.service'
import { map, mergeMap } from 'rxjs/operators'
import * as appComponentStore from '../actions/user.action'
import * as adminInfoStore from '../actions/adminuser.action'
import { ToastrService } from 'ngx-toastr'
import { AdminapiService } from 'src/app/shared/services/adminapi.service'

@Injectable()
export class AppEffect {
  constructor(private _svc: WebapiService,private _adminsvc: AdminapiService, private actions$: Actions,private toastrService: ToastrService) { }

  @Effect()
  userInfo = this.actions$.pipe(
    ofType(appComponentStore.UserActionType.GET_INFO),
    mergeMap(action => this._svc.getUserData().pipe(
        map((result: any) => {
            //console.log(result)
            //return result
            if (result && result.success==1) {
                return new appComponentStore.UserInfoSuccess(result);
            }else{
              this.toastrService.error("Invalid response");
            }
            return null
            // return actions.gapiAuthSuccess('notlogged');
        })
    ))
    
  )

  @Effect()
  adminuserInfo = this.actions$.pipe(
    ofType(adminInfoStore.AdminUserActionType.GETAdmin_INFO),
    mergeMap(action => this._adminsvc.getUserData().pipe(
        map((result: any) => {
            //return result
            if (result && result.success==1) {
                return new adminInfoStore.AdminUserInfoSuccess(result);
            }else{
              this.toastrService.error("Invalid response");
            }
            return null
            // return actions.gapiAuthSuccess('notlogged');
        })
    ))
  )
}